import React, { useEffect, useRef, useState} from 'react';
import { WalletCards, HandCoins, SquarePen, X, Save, Loader } from 'lucide-react';
import { can_visit, notify, numberWithCommas } from "../../../helpers";
import { Config } from '../../../Config';
import { getGapsInCareStatus } from '../../../services/dashboard';
import { qualityIncentivePayment, updateQualityIncentivePayment } from '../../../services/audits';
import { Drawer } from 'vaul';
import Spacing from '../../Spacing';
import Card from '../../Card';
import Grid from '../../Grid';
import GapsInCare from '../../Section/GapsInCare';

export default function QualityIncentivePaymentModal({
  account_id,
  location_id,
  activeModal = false,
  setActiveModal = () => {}
}) {

  const [loadData, setLoadData] = useState(true);
  const [gapsInCareData, setGapsInCareData] = useState([]);
  const [potentialRevenueData, setPotentialRevenueData] = useState([]);
  const [editQualityIncentive, setEditQualityIncentive] = useState(false);
  const [saveQualityIncentiveLoader, setSaveQualityIncentiveLoader] = useState(false);
  const dropdownRef = useRef(null);

  const [formData, setFormData] = useState({
    account_id: account_id,
    location_id: location_id,
    potential_revenue: 0
  });

  const getGapsInCareData = async (locationId, accountId) => {
    try {
      const response = await getGapsInCareStatus({
        location_id: locationId,
        account_id: accountId,
      });
      
      if (response) {
        setGapsInCareData(response?.data);
        setLoadData(false);
      }
    } catch (error) {
      // console.log("🚀 ~ getGapsInCareData ~ error:", error);
    }
  };
  
  useEffect(() => {
    getGapsInCareData(location_id, account_id);
  },[location_id, account_id])
  
  const getPotentialRevenue = async (locationId, accountId) => {
    try {
      const response = await qualityIncentivePayment(locationId, accountId);
      
      if (response) {
        setPotentialRevenueData(response?.data);
        setPrecisionFormData(response?.data);
      }
    } catch (error) {
      // console.log("🚀 ~ getGapsInCareData ~ error:", error);
    }
  };

  const setPrecisionFormData = (data) => {
    setFormData({
      account_id: account_id,
      location_id: location_id,
      ...data
    });
  };

  useEffect(() => {
    getPotentialRevenue(location_id, account_id);
  },[location_id, account_id])

  const handleInputChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleCancelEdit = () => {
    setPrecisionFormData(potentialRevenueData);
    setEditQualityIncentive(false);
  };

  const updateCareManagementReport = async (e) => {
    e.preventDefault();
    setSaveQualityIncentiveLoader(true);

    try {
      const response = await updateQualityIncentivePayment(formData);
      if(response){
        if(response?.detail) {
          notify("error", response?.detail);
        } else {
          if(response?.data?.status === 'success') {
            notify("success", response?.data?.message);
            await getPotentialRevenue(account_id, location_id);
            setEditQualityIncentive(false);
          } else  {
            notify("error", response?.data?.message);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 1);
      }
    } finally {
      setSaveQualityIncentiveLoader(false);
    }
  }

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={setActiveModal}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Patient Details</Drawer.Title>
            <Drawer.Description className="sr-only">View details of a parient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">

              <div className="docpro_modal" style={{ backgroundColor: 'rgb(249, 249, 251)' }}>
                {loadData ? (
                  <div
                    style={{
                      height: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Loading...
                  </div>
                ) : (
                  <>
                    <form onSubmit={updateCareManagementReport}>
                      <div className="docpro_page_heading_wrap audit_modal_heading">
                        <h2 className="docpro_page_heading docpro_fs_24">
                          <i
                            className="docpro_white_color"
                            style={{ backgroundColor: "#28b8cf" }}
                          >
                            <HandCoins width={18} height={18} />
                          </i>
                          Quality Incentive Payment
                        </h2>
                          <div className="docpro_page_heading_btns">
                            {can_visit('administrator') && (
                            !editQualityIncentive ?
                              <button 
                                type="button"
                                className="docpro_bordered_btn" 
                                style={{ background: '#1578d5', borderRadius: '5px', color: '#ffffff' }}
                                onClick={()=>{setEditQualityIncentive(true);}}
                              >
                                <SquarePen width={20} height={20} />
                                <span>Edit</span>
                              </button>
                            :
                              <div className="flex item-center docpro_grid_gap_10">
                                <button 
                                  type="button"
                                  className="docpro_bordered_btn" 
                                  style={{ background: '#e5484d', borderRadius: '5px', color: '#ffffff' }}
                                  onClick={handleCancelEdit}
                                >
                                  <X width={20} height={20} />
                                  <span>Cancel</span>
                                </button>
                                {editQualityIncentive && (
                                  <button
                                    type="submit"
                                    style={{ borderRadius: '4px' }}
                                    className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                                    disabled={saveQualityIncentiveLoader ? true : false}
                                  >
                                    <Save width={18} height={18} />
                                    <span>Save</span>
                                    {saveQualityIncentiveLoader && (
                                      <span className="docpro_loading">
                                        <Loader width={20} height={20} />
                                      </span>
                                    )}
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                      </div>

                      <Grid variant="docpro_grid_gap_20 docpro_grid_col_3">
                        <div className="docpro_card docpro_card_md docpro_card_1">
                          <h3 className="docpro_fs_14 docpro_mb_0 docpro_olive_color">
                            <WalletCards /> 
                            Potential Revenue
                          </h3>
                          <Spacing lg="5" sm="5" />
                          <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
                            {!editQualityIncentive ? 
                              <>${numberWithCommas(potentialRevenueData?.potential_revenue? numberWithCommas(potentialRevenueData?.potential_revenue) : 0.00)}</>
                            :
                              <span className="docpro_signout_input items-center">
                                $
                                <input
                                  type="text"
                                  className="docpro_fw_500"
                                  style={{ maxWidth: "160px" }}
                                  defaultValue={formData?.potential_revenue || 0}
                                  onChange={(e) => handleInputChange("potential_revenue", e.target.value)}
                                />
                              </span>
                            }
                        </p>
                        </div>
                      </Grid>
                      <Spacing lg="18" sm="18" />
                      <Card variant="docpro_card docpro_card_1">
                        <div className='flex items-center'>
                          <img src="/images/favicon.png" width={45} alt="Icon" className='mr-4' />
                          <ul className='docpro_mb_0 docpro_fs_16'>
                            <li>{Config?._AppName} CareGap plus provides you subjective care gap list for each patient.</li>
                            <Spacing lg="5" sm="5" />
                            <li>Using Pre-visit planning & Automated outreach, you can close the caregaps.</li>
                          </ul>
                        </div>
                      </Card>
                      <Spacing lg="22" sm="22" />

                      <GapsInCare GapsInCareStatus={gapsInCareData} audit={true} />
                    </form>
                  </>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}